// extracted by mini-css-extract-plugin
module.exports = {"bonusCash":"_597ddac","bonusCashAmount":"_c97b099","bonusCashExpiry":"_5237e2d","iconChevron":"_93e15eb"};